import { SHIPPING_INFO_TYPES, type ShippingInfoType } from '../constants';
import FacilityDisplay from './FacilityDisplay';
import OneTimeAddressDisplay from './OneTimeAddressDisplay';

type ShippingInformationDisplayProps = {
  facility: any;
  shippingInformation: any;
  type: ShippingInfoType;
};

const ShippingInformationDisplay = ({
  facility,
  shippingInformation,
  type,
}: ShippingInformationDisplayProps) => {
  switch (type) {
    case SHIPPING_INFO_TYPES.NONE:
      return 'None';
    case SHIPPING_INFO_TYPES.ONE_TIME_ADDRESS:
      return <OneTimeAddressDisplay address={shippingInformation} />;
    case SHIPPING_INFO_TYPES.FACILITY:
      return <FacilityDisplay facility={facility} />;
    default:
      return 'None';
  }
};

export default ShippingInformationDisplay;
